const _4 = require('lodash4');
import { ITermCourse, ISectionType } from '../../../../interfaces/scheduler_interfaces';
import { RegisterSectionsQuery } from '../../../course_scheduler/queries/register_sections_query';
import { CommunicatorService } from 'ui-ng-component-communicator';
import { RegistrationOneClickQuery } from '../../queries/registration_one_click_query';
import { PayTuitionQuery } from '../../queries/pay_tuition_query';
import { PayTuitionFacade } from '../../facades/pay_tuition_facade';
import { RegistrationFacade } from '../../facades/registration_facade';
import { RegistrationSelectedSectionsQuery } from '../../queries/registration_selected_sections_query';

class RegistrationActions {
  private sectionsQuantityMsg: string;
  private showPayTuition: boolean = true;
  private attachTermPinRegister: boolean = false;
  private isRequestPending: boolean = false;
  private saveTermPinAndContinueBound: any;
  private registrationPrecheckUpdatedBound: any;

  constructor(
    private ngRegisterSectionsQuery: RegisterSectionsQuery,
    private ngComponentCommunicatorService: CommunicatorService,
    private registrationRTRSvc: any,
    private ngRegistrationOneClickQuery: RegistrationOneClickQuery,
    private ngPayTuitionQuery: PayTuitionQuery,
    private ngPayTuitionFacade: PayTuitionFacade,
    private ngRegistrationFacade: RegistrationFacade,
    private ngRegistrationSelectedSectionsQuery: RegistrationSelectedSectionsQuery
  ) {
    this.registrationPrecheckUpdatedBound = this.ngRegistrationFacade.registrationPrecheckUpdated;
    this.saveTermPinAndContinueBound = this.ngRegistrationFacade.saveTermPinAndContinue;
  }
  $onInit() {
    this.ngComponentCommunicatorService.subscribe(
      'REGISRATION_PRE_CHECK_SUCCESS',
      this.registrationPrecheckUpdatedBound
    );
    this.ngComponentCommunicatorService.subscribe('REGISRATION_PRE_CHECK_FAIL', this.registrationPrecheckUpdatedBound);
    this.subscribeToTermPINAction();
  }

  subscribeToTermPINAction() {
    if (_4.toString(this.attachTermPinRegister).toLowerCase() === 'true') {
      this.ngComponentCommunicatorService.subscribe('SAVE_TERM_PIN_AND_CONTINUE', this.saveTermPinAndContinueBound);
    }
  }

  $onChanges() {
    this.subscribeToTermPINAction();
  }

  $onDestroy() {
    this.ngComponentCommunicatorService.release('REGISRATION_PRE_CHECK_SUCCESS', this.registrationPrecheckUpdatedBound);
    this.ngComponentCommunicatorService.release('REGISRATION_PRE_CHECK_FAIL', this.registrationPrecheckUpdatedBound);
    if (_4.toString(this.attachTermPinRegister).toLowerCase() === 'true') {
      this.ngComponentCommunicatorService.release('SAVE_TERM_PIN_AND_CONTINUE', this.saveTermPinAndContinueBound);
    }
  }

  shouldDisableRegisterAtButton() {
    const registrationUrl = this.registrationRTRSvc.init(this.ngRegisterSectionsQuery.result.scheduledSections);
    const hasScheduledSelectedSections = this.ngRegisterSectionsQuery.result.selectedSections.length > 0;
    return (
      !hasScheduledSelectedSections ||
      _4.isEmpty(registrationUrl) ||
      !this.registrationRTRSvc.hasCrns() ||
      this.isRequestPending
    );
  }

  isRegistrationPortalURLEmpty() {
    const registrationPortalURL = this.registrationRTRSvc.init(this.ngRegisterSectionsQuery.result.scheduledSections);
    return _4.isEmpty(registrationPortalURL);
  }

  selectedCourseIdsWithSessions() {
    const courseIdsWithSessions: Record<ITermCourse['id'], NonNullable<ISectionType['session']>> = {};
    const coursesScheduledById = _4.groupBy(this.ngRegisterSectionsQuery.result.selectedSections, '_course.id');
    _4.each(
      coursesScheduledById,
      (sections, courseId) =>
        (courseIdsWithSessions[courseId!] = _4.map(sections, (section) => _4.get(section, '_section_type.session')))
    );
    return courseIdsWithSessions;
  }

  isRegistrationPending() {
    return this.isRequestPending;
  }
}

angular.module('capability-ng-scheduler').component('registrationActions', {
  templateUrl:
    'capability-ng-scheduler/src/views/registration/components/registration_actions/registration_actions_component.html',
  bindings: {
    showPayTuition: '<',
    attachTermPinRegister: '<'
  },
  controller: RegistrationActions
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/registration/components/registration_actions/registration_actions_component.ts